module.exports = __webpack_public_path__ + "static/media/FangDiChan4.0b4abb46.png";